
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-modal
      id="simulation-info-modal"
      modal-class="giga-modal modal-notification info-modal"
      size="lg"
      footer-class="info-footer"
      hide-header
      no-close-on-backdrop
      centered
      lazy
  >
    <h2 class="giga-modal_title">Les fiches suivantes ne sont pas actuellement disponibles pour une simulation automatisée :</h2>
    <div class="giga-modal_body">
      <ul class="giga-modal_list">
        <li class="giga-modal_list_item">
          <i class="error-icon"></i>
          <p>Chaudière collective haute performance énergétique (BAR-TH-107)</p>
        </li>
        <li class="giga-modal_list_item">
          <i class="error-icon"></i>
          <p>Chaudière collective haute performance énergétique avec contrat assurant la conduite de l’installation 1 (BAR-TH-107 SE)</p>
        </li>
        <li class="giga-modal_list_item">
          <i class="error-icon"></i>
          <p>Radiateur basse température pour un chauffage central (BAR-TH-105)</p>
        </li>
        <li class="giga-modal_list_item">
          <i class="error-icon"></i>
          <p>Chaudière collective haute performance énergétique (BAT-TH-102)</p>
        </li>
        <li class="giga-modal_list_item">
          <i class="error-icon"></i>
          <p>Système de variation électronique de vitesse sur une pompe (BAR-TH-139)</p>
        </li>
      </ul>
    </div>
    <template #modal-footer>
      <div class="giga-modal_footer">
        <div class="row">
          <div class="col-lg-9 align-items">
            <p>Afin d'effectuer une simulation sur l'une de ces fiches, veuillez sélectionner le choix suivant lors de la création de votre simulation:</p>
          </div>
          <div class="col-lg-3 flex-end">
            <div class="giga-button">
              <button class="giga-blue_button no-icon" @click="hideSimulationInfoModal()">D'accord</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'SimulationInfoModal',
  methods: {
    ...mapActions('notification', ['openModal', 'closeModal']),
    hideSimulationInfoModal() {
      this.closeModal({instance: this.$root, id: 'simulation-info-modal'})
    },
  }
}
</script>
<style lang='scss'>
  .info-modal {
    .modal-content {
      overflow: hidden;
      min-height: 500px;
      height: auto;
      background-image: image('bg-modal-notifcation.svg', 'assets/');
      background-position-x: 3% !important;
      background-position-y: 60% !important;
      background-size: 300px !important;
    }
  }
  .fiches-container {
    margin-right: 15%;
  }
</style>
